export type Widths = 'wide' | 'medium' | 'narrow' | 'extraLarge' | 'full';

export const widths = {
  extraLarge: '100rem',
  wide: '51rem',
  medium: '45.6rem',
  narrow: '39rem',
  full: '100%',
};
